<template>
    <div v-if="visible" :id="modalId" :class="['modal__popup overlay', customClass]"
        style="visibility: visible; opacity: 1;">
        <div class="popup__wrap" :class="size">
            <div class="popup__head">
                <slot name="title">
                    <h4 class="title">{{ title }}</h4>
                </slot>
                <div class="popup__close__btn">
                    <a href="javascript:void(0);" class="close_btn" @click="$emit('close')">
                        <img :src="closeIcon" alt="Close" />
                    </a>
                </div>
            </div>

            <div class="sepline__divider" v-if="title"></div>

            <div class="popup__content__box" :style="contentBoxStyle" ref="contentBoxRef" @scroll="handleScroll">
                <slot />
            </div>

            <div class="popup__footer rlms-w-100" v-if="$slots.footer">
                <slot name="footer" />
            </div>
        </div>

    </div>
</template>

<script setup>
import closeIcon from '@/assets/images/popup-close-icon.png'
import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
// eslint-disable-next-line
const props = defineProps({
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    size: {
        type: String,
        default: 'medium', // small | medium | large | extra-large
    },
    modalId: {
        type: String,
        default: null,
    },
    customClass: {
        type: String,
        default: '',
    },
    sepline: {
        type: Boolean,
        default: true,
    },
});
// eslint-disable-next-line
const emit = defineEmits(['close', 'scrollEnd']);

const contentBoxRef = ref(null);
const hasVerticalScroll = ref(false);
const hasScrolledToEnd = ref(false);

let observer

const checkScroll = () => {
    setTimeout(() => {
        const el = contentBoxRef.value;
        if (!el) return;

        hasVerticalScroll.value = el.scrollHeight > el.clientHeight;
    }, 0);
}

const handleScroll = () => {
    const el = contentBoxRef.value
    if (!el) return

    const atBottom =
        el.scrollTop + el.clientHeight >= el.scrollHeight - 10 // 10px buffer
    hasScrolledToEnd.value = atBottom

    if(hasScrolledToEnd.value) {
        emit('scrollEnd');
    }

}

// Disable scroll on open, re-enable on close
watch(() => props.visible,
    (newVal) => {
        bodyScroll(newVal);
    }
);

onMounted(() => {
    bodyScroll(props.visible);

    // Initial check
    checkScroll()
    // Watch for resize
    observer = new ResizeObserver(checkScroll)
    if (contentBoxRef.value) {
        observer.observe(contentBoxRef.value)
    }
});


// Clean up when modal component is destroyed
onUnmounted(() => {
    bodyScroll(false);

    if (observer && contentBoxRef.value) {
        observer.unobserve(contentBoxRef.value)
    }
});

const contentBoxStyle = computed(() => {
    return {
        paddingRight: hasVerticalScroll.value ? '10px' : '0px',
    }
});

const bodyScroll = (e) => {
    if (e) {
        document.body.style.overflow = 'hidden';
    } else {
        document.body.style.overflow = '';
    }
}
</script>

<style>
.popup__content__box {
    max-height: 600px;
    overflow-y: auto;
    overflow-x: hidden;
}

.video__popup__box .popup__content__box {
    max-height: 682.5px;
}

@media (max-height: 813px) {
    .popup__content__box {
        max-height: 400px;
    }
}
</style>